import fetch, { METHOD } from '../fetch'

export const get = async (token) => {
  const { status, attributes } = await fetch(METHOD.GET, '/filter/get', { token })
  if (status && attributes) {
    return attributes
  }
  return false
}
